import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { QuoteItemBaqData, MutationFunction } from '@frontend/api';

export type MergeQuoteItemsAsComponentsQueryVars = {
  quoteId: number;
  parentId: number;
  childrenIds: number[];
  shouldRegenerateOps: boolean;
};

export const getMergeQuoteItemsAsComponentsKey = () =>
  ['quotes', 'quoteItems', 'mergeAsComponents'] as const;

export const useMergeQuoteItemsAsComponents: MutationFunction<
  QuoteItemBaqData,
  MergeQuoteItemsAsComponentsQueryVars
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    ({ quoteId, ...body }) =>
      request(`/quotes/${quoteId}/merge_items_as_components`, {
        init: { method: 'POST', body },
      }),
    {
      ...queryOptions,
      mutationKey: getMergeQuoteItemsAsComponentsKey(),
    },
  );
};
